var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { CollectionColumnTitle } from './collection-column-title';
import { CollectionGroup } from './collection-group';
import { cs, generateAggregate, getCollectionGroups } from '../utils';
import { Property } from './property';
import { useNotionContext } from '../context';
import { UseRetrieveBlocks } from '../hooks/useRetrieveBlocks';
export var CollectionViewTable = function (_a) {
    var _b, _c;
    var collection = _a.collection, collectionView = _a.collectionView, collectionData = _a.collectionData, padding = _a.padding, width = _a.width;
    var isGroupedCollection = (_b = collectionView === null || collectionView === void 0 ? void 0 : collectionView.format) === null || _b === void 0 ? void 0 : _b.collection_group_by;
    var retrieveMissingCollections = UseRetrieveBlocks().retrieveMissingCollections;
    if (isGroupedCollection) {
        var collectionGroups = getCollectionGroups(collection, collectionView, collectionData, padding, width);
        if (isGroupedCollection.hideEmptyGroups)
            collectionGroups = collectionGroups.filter(function (g) { return g.blockIds.length > 0; });
        return collectionGroups.map(function (group, index) { return (React.createElement(CollectionGroup, __assign({ key: index }, group, { collectionViewComponent: function (props) { return (React.createElement(Table, __assign({}, props, { padding: padding, width: width }))); }, summaryProps: {
                style: {
                // paddingLeft: padding,
                // paddingRight: padding
                }
            } }))); });
    }
    // this does the same thing as the retrieveBlocks function in utils
    // but i'm yet to test this, please test before replacing.
    var blockIds = Object.keys(collectionData)
        .filter(function (key) { return collectionData[key].type == 'results'; })
        .map(function (key) { return collectionData[key].blockIds; })
        .find(function (ids) { return ids.length > 0; });
    if (((_c = (blockIds || [])) === null || _c === void 0 ? void 0 : _c.length) == 0) {
        var filters = collectionView.format.property_filters;
        var reducers = __assign({ reducers: {
                collection_group_results: {
                    type: 'results',
                    limit: 50,
                    loadContentCover: false
                }
            } }, (filters ? { filters: filters } : null));
        console.log('no collection data to show... fetching collection data');
        retrieveMissingCollections(collection.id, collectionView.id, reducers);
    }
    return (React.createElement(Table, { blockIds: blockIds, collection: collection, collectionView: collectionView, width: width }));
};
function Table(_a) {
    var _b, _c, _d;
    var blockIds = _a.blockIds, collection = _a.collection, collectionView = _a.collectionView, width = _a.width;
    var recordMap = useNotionContext().recordMap;
    var properties = [];
    if ((_b = collectionView.format) === null || _b === void 0 ? void 0 : _b.table_properties) {
        properties = (_c = collectionView.format) === null || _c === void 0 ? void 0 : _c.table_properties.filter(function (p) { return p.visible && collection.schema[p.property]; });
    }
    else {
        properties = [{ property: 'title' }].concat(Object.keys(collection.schema)
            .filter(function (p) { return p !== 'title'; })
            .map(function (property) { return ({ property: property }); }));
    }
    var aggregations = {};
    for (var _i = 0, _e = ((_d = collectionView.query2) === null || _d === void 0 ? void 0 : _d.aggregations) || []; _i < _e.length; _i++) {
        var agg = _e[_i];
        if (agg.property) {
            aggregations[agg.property] = agg.aggregator;
        }
    }
    return (React.createElement("div", { className: 'notion-table', style: {
            // width
            maxWidth: width
        } },
        React.createElement("div", { className: 'notion-table-view', style: {
            // paddingLeft: padding,
            // paddingRight: padding
            } }, !!properties.length && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'notion-table-header' },
                React.createElement("div", { className: 'notion-table-header-inner' }, properties.map(function (p) {
                    var _a;
                    var schema = (_a = collection.schema) === null || _a === void 0 ? void 0 : _a[p.property];
                    var isTitle = p.property === 'title';
                    var style = {};
                    if (p.width) {
                        style.width = p.width;
                    }
                    else if (isTitle) {
                        style.width = 280;
                    }
                    else {
                        style.width = 200;
                        // style.width = `${100.0 / properties.length}%`
                    }
                    return (React.createElement("div", { className: 'notion-table-th', key: p.property },
                        React.createElement("div", { className: 'notion-table-view-header-cell', style: style },
                            React.createElement("div", { className: 'notion-table-view-header-cell-inner' },
                                React.createElement(CollectionColumnTitle, { schema: schema })))));
                }))),
            React.createElement("div", { className: 'notion-table-header-placeholder' }),
            React.createElement("div", { className: 'notion-table-body' }, blockIds === null || blockIds === void 0 ? void 0 : blockIds.map(function (blockId) { return (React.createElement("div", { className: 'notion-table-row', key: blockId }, properties === null || properties === void 0 ? void 0 : properties.map(function (p) {
                var _a, _b, _c, _d, _e, _f;
                var schema = (_a = collection.schema) === null || _a === void 0 ? void 0 : _a[p.property];
                var block = (_b = recordMap.block[blockId]) === null || _b === void 0 ? void 0 : _b.value;
                var data = (_c = block === null || block === void 0 ? void 0 : block.properties) === null || _c === void 0 ? void 0 : _c[p.property];
                var isTitle = p.property === 'title';
                var tableProperties = (_d = collectionView.format) === null || _d === void 0 ? void 0 : _d.table_properties;
                var style = {
                    whiteSpace: 'nowrap'
                };
                if (tableProperties) {
                    // find the prop
                    for (var _i = 0, _g = tableProperties || []; _i < _g.length; _i++) {
                        var prop = _g[_i];
                        if ((prop === null || prop === void 0 ? void 0 : prop.property) == p.property &&
                            'wrap' in prop &&
                            prop.wrap) {
                            style.whiteSpace = 'normal';
                            break;
                        }
                    }
                }
                if (p.width) {
                    style.width = p.width;
                }
                else if (isTitle) {
                    style.width = 280;
                }
                else {
                    style.width = 200;
                    // style.width = `${100.0 / properties.length}%`
                }
                var isLink = (((_f = (_e = data === null || data === void 0 ? void 0 : data.flat()) === null || _e === void 0 ? void 0 : _e.flat()) === null || _f === void 0 ? void 0 : _f.flat()) || []).length == 3;
                return (React.createElement("div", { key: p.property, className: cs('notion-table-cell', "notion-table-cell-".concat(schema.type), isLink ? 'notion-table-cell-page' : ''), style: style },
                    React.createElement(Property, { schema: schema, data: data, block: block, collection: collection })));
            }))); })),
            Object.keys(aggregations).length > 0 && (React.createElement("div", { className: 'notion-table-row' }, properties === null || properties === void 0 ? void 0 : properties.map(function (p) {
                var _a;
                // const schema = collection.schema?.[p.property]
                var property = p === null || p === void 0 ? void 0 : p.property;
                var isTitle = property === 'title';
                var style = {};
                if (p.width) {
                    style.width = p.width;
                }
                else if (isTitle) {
                    style.width = 280;
                }
                else {
                    style.width = 200;
                }
                var operator = '';
                operator =
                    ((_a = aggregations === null || aggregations === void 0 ? void 0 : aggregations[property]) === null || _a === void 0 ? void 0 : _a['operator']) ||
                        (aggregations === null || aggregations === void 0 ? void 0 : aggregations[property]);
                if (property !== 'title' && !operator) {
                    var splits = operator === null || operator === void 0 ? void 0 : operator.split('_');
                    if (splits)
                        operator =
                            splits.length > 2 ? splits[0] : splits.slice(-1)[0];
                }
                return (React.createElement("div", { className: 'notion-table-aggregation', key: property, style: style },
                    React.createElement("span", { className: 'notion-table-aggregation-type' }, operator),
                    React.createElement("span", { className: 'notion-table-aggregation-value' }, operator
                        ? generateAggregate(operator, property, blockIds, recordMap.block)
                        : ' ')));
            }))))))));
}
//# sourceMappingURL=collection-view-table.js.map